import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (param) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'POST_FILES',
    method: 'POST',
  });

  useEffect(() => {
    if (param.url) {
      exec({ url: param.url, data: param.data });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return isRequestSuccessed;
});
